<template>
  <div class="w-100">
    <HotelTopNavbar />
    <block :height="83" />
    <div :class="$is_mobile_view ? 'mb-4' : 'my-5'">
      <HotelCheckoutStepper :steps="steps" :current-step="currentStep" />
    </div>

    <AdditionalService
      @update-step="updateCurrentStep"
      v-if="sourceModule === 'additional-service'" />
    <template v-else>
      <Mobile v-if="is_mobile" @update-step="updateCurrentStep"></Mobile>
      <Desktop v-else @update-step="updateCurrentStep"></Desktop>
    </template>

    <Footer />
  </div>
</template>
<script>
import Desktop from '@/pages/hotel/be/BePaymentResultDesktop';
import Mobile from '@/pages/hotel/be/BePaymentResultMobile';
import AdditionalService from './BePaymentResultAdditionalService.vue';
import GeneralTopNavbar from '@/components/general/GeneralTopNavbar.vue';
import HotelTopNavbar from '../../../components/hotel/HotelTopNavbar.vue';
import HotelCheckoutStepper from '../../../components/hotel/be/HotelCheckoutStepper.vue';
import Footer from '@/components/hotel/Footer.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Desktop,
    Mobile,
    AdditionalService,
    GeneralTopNavbar,
    Footer,
    HotelTopNavbar,
    HotelCheckoutStepper,
  },
  metaInfo() {
    return {
      title: 'Payment Result',
      titleTemplate: this.getMetaTitleTemplate(),
    };
  },
  data() {
    return {
      is_mobile: true,
      steps: [
        { order: 1, title: 'Your Selection' },
        { order: 2, title: 'Your Details' },
        { order: 3, title: 'Final Step' },
      ],
      viewType: 'FORM', // ["FORM", "PAYMENT"]
      currentStep: 3,
    };
  },
  computed: {
    sourceModule() {
      return this.$isNotEmptyV2(this.$route.query.module)
        ? this.$route.query.module
        : 'room';
    },
  },
  created() {
    if (window.innerWidth > 768) {
      this.is_mobile = false;
    }
  },
  methods: {
    ...mapGetters(['getMetaTitleTemplate']),
    updateCurrentStep(newStep) {
      this.currentStep = newStep;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/be/BePaymentResult.vue